import script from "./EntitlementsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EntitlementsPage.vue?vue&type=script&setup=true&lang=js"

export default script